var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fade-transition',{attrs:{"duration":{enter: _vm.enterDuration, leave: _vm.leaveDuration}}},[_c('full-screen-modal',{attrs:{"hideSubmitButton":"true","id":"transition-overlay-modal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }